import styled from 'styled-components';
import {
  FlexCenter,
  FlexColumn,
  FloatingActionsMenu,
} from '@elementary/common-ui/components';
import { CircularProgress } from '@mui/material';
import NoEnvPage from 'shared/components/NoEnvPage';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import useViewLoadTracking from '@elementary/common-ui/hooks/useViewLoadTracking';
import useContainerBreakpoint from '@elementary/common-ui/hooks/useContainerBreakpoint';
import ErrorPage from 'app/components/ErrorPage';
import useDataHealthFilters from '../hooks/useDataHealthFilters';
import useDataHealth from '../hooks/useDataHealth';
import DataHealthSummary from './DataHealthSummary';
import Header from './Header';
import QualityDimensionScores from './QualityDimensionScores';

const NARROW_BREAKPOINT = { key: 'narrow', width: 1300 };

const DataHealthContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Wrapper = styled(FlexColumn)`
  flex: 1;
  gap: 32px;
  padding: 24px;
  padding-bottom: 100px;
  width: 1274px;
  margin: 0 auto;

  [data-narrow] & {
    width: 852px;
  }
`;

const CenteringWrapper = styled(FlexCenter)`
  height: 100%;
`;

const Content = styled(FlexColumn)`
  gap: 32px;
  padding-bottom: 32px;
`;

const DataHealth = () => {
  const { ref: containerRef } = useContainerBreakpoint([NARROW_BREAKPOINT]);
  const selectedEnvId = useSelectedEnv();
  const { urlFilters } = useDataHealthFilters();
  const { data, isFetching, refetch, error } = useDataHealth();

  useViewLoadTracking({
    name: 'Data Health',
    loadDeps: [data],
    contextId: JSON.stringify(urlFilters),
  });

  if (!selectedEnvId) return <NoEnvPage />;

  return (
    <DataHealthContainer ref={containerRef}>
      <Wrapper>
        <Header />

        {isFetching === true && (
          <CenteringWrapper>
            <CircularProgress />
          </CenteringWrapper>
        )}

        {!!error && (
          <ErrorPage
            error={error as Error}
            errorName={'ApiError'}
            page={'DataHealth'}
          />
        )}

        {isFetching === false && data !== undefined && (
          <Content>
            <DataHealthSummary
              tests={data.tests}
              totalScore={data.totalScore}
              scoreOverTime={data.scoreOverTime}
              onTotalHealthScoreFormulaChange={() => {
                refetch();
              }}
              selectedFilters={urlFilters}
            />

            <QualityDimensionScores
              qualityDimensions={data.qualityDimensions}
              onQualityDimensionThresholdsChange={() => {
                refetch();
              }}
            />
          </Content>
        )}
      </Wrapper>
      <FloatingActionsMenu sticky />
    </DataHealthContainer>
  );
};

export default DataHealth;
